module.exports = __webpack_public_path__ + "static/media/booking6.37866ceb.jpg";